import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import Profile from "../account/Profile";
import Preferences from "../account/Preferences";
import ChangePassword from "../account/ChangePassword";
import WorkbookHubPage from "../organization/workbook/WorkbookHubPage";
import WorkbookOverviewPage from "../organization/workbook/WorkbookOverviewPage";
import WorkbookInterpretationPage from "../organization/workbook/WorkbookInterpretationPage";
import WorkbookWidgetsPage from "../organization/workbook/WorkbookWidgetsPage";
import NetworkDashboard from "./NetworkDashboard";
import NetworkEntryPage from "./NetworkEntryPage";
import NetworkAdminRouteGuard from "./NetworkAdminRouteGuard";
import NetworkOrganizationCreate from "./NetworkOrganizationCreate";
import NetworkOrganizationEdit from "./NetworkOrganizationEdit";
import NetworkOrganizationView from "./NetworkOrganizationView";
import NetworkOrganizationsPage from "./NetworkOrganizationsPage";
import NetworkAggregateReportRoutes from "./report/NetworkReportRoutes";
import NetworkReportRoutes from "./NetworkReportRoutes";
import NetworkResultsPage from "./NetworkResultsPage";
import NetworkRouteGuard from "./NetworkRouteGuard";
import NetworkSelectionPage from "./NetworkSelectionPage";
import NetworkSettingsPage from "./NetworkSettingsPage";
import UserRoutes from "../users/UserRoutes";

const NetworkUserRoutes = () => {
  const { networkId } = useParams();

  return (
    <UserRoutes
      context={{ type: "network", id: networkId }}
      basePath={`/app/network/${networkId}/users`}
      title="Users"
      description="Manage users within this network and its schools."
      scope="network"
      allowGlobalCreate={true}
    />
  );
};

const guarded = (element) => (
  <NetworkRouteGuard>
    {element}
  </NetworkRouteGuard>
);

const adminGuarded = (element) => guarded(
  <NetworkAdminRouteGuard>
    {element}
  </NetworkAdminRouteGuard>
);

const NetworkRoutes = () => (
  <Routes>
    <Route path="" element={<NetworkEntryPage />} />
    <Route path="select" element={<NetworkSelectionPage />} />
    <Route path=":networkId" element={guarded(<NetworkDashboard />)} />
    <Route path=":networkId/organizations" element={guarded(<NetworkOrganizationsPage />)} />
    <Route path=":networkId/organizations/new" element={adminGuarded(<NetworkOrganizationCreate />)} />
    <Route path=":networkId/organizations/:organizationId/edit" element={adminGuarded(<NetworkOrganizationEdit />)} />
    <Route path=":networkId/organizations/:organizationId" element={guarded(<NetworkOrganizationView />)} />
    <Route path=":networkId/organizations/:organizationId/workbook" element={guarded(<WorkbookHubPage />)} />
    <Route path=":networkId/organizations/:organizationId/workbook/:kind" element={guarded(<WorkbookOverviewPage />)} />
    <Route path=":networkId/organizations/:organizationId/workbook/pages/:pageId" element={guarded(<WorkbookInterpretationPage />)} />
    <Route path=":networkId/organizations/:organizationId/workbook/pages/:pageId/widgets" element={guarded(<WorkbookWidgetsPage />)} />
    <Route path=":networkId/report/*" element={guarded(<NetworkAggregateReportRoutes />)} />
    <Route path=":networkId/results" element={guarded(<NetworkResultsPage />)} />
    <Route path=":networkId/results/*" element={guarded(<NetworkReportRoutes />)} />
    <Route path=":networkId/users/*" element={adminGuarded(<NetworkUserRoutes />)} />
    <Route path=":networkId/network-settings" element={adminGuarded(<NetworkSettingsPage />)} />
    <Route path=":networkId/profile" element={guarded(<Profile />)} />
    <Route path=":networkId/settings" element={guarded(<Preferences />)} />
    <Route path=":networkId/password" element={guarded(<ChangePassword />)} />
  </Routes>
);

export default NetworkRoutes;
